import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { StateService } from '../../services/state';
import { Api } from '../../services/api';
import { firstValueFrom } from 'rxjs';
import { DatosPoliza } from '../../models/datosPoliza';

@Component({
  selector: 'app-payment-result',
  imports: [CommonModule, RouterModule, MatButtonModule, MatCardModule],
  templateUrl: './payment-result.html',
  styleUrl: './payment-result.scss',
})
export class PaymentResult {
  private readonly router = inject(Router);
  private readonly stateService = inject(StateService);
  private readonly api = inject(Api);
  private readonly cdr = inject(ChangeDetectorRef);
  state: any;
  numPoliza: string = '';
  tkn: string = '';
  result: 'ok' | 'ko';
  policyErrorMessage: string = '';
  isLoadingPolicyData: boolean = false;

  constructor(private route: ActivatedRoute) {
    this.result = this.route.snapshot.data['result'];
  }

  async ngOnInit() {
    this.state = this.stateService.getState(false) || {};

    const urlParams = this.route.snapshot.queryParams;
    const paymentResult = Object.assign({}, urlParams, { result: this.result });

    // El cId sempre torna per url; el token només si encara conservem l'estat.
    // Si hem perdut l'estat (p.ex. el navegador ha tornat de la passarel·la en
    // un context diferent) hem d'avisar igualment l'api: el cobrament ja s'ha
    // fet i l'api sap resoldre l'oferta a partir del cId.
    if (!paymentResult['cId']) {
      this.router.navigate(['/']);
      return;
    }

    this.state.paymentResult = paymentResult;
    this.stateService.setState(this.state);
    this.numPoliza = String(this.state?.datosPoliza?.polizaId || '');

    this.isLoadingPolicyData = true;
    try {
      const response: any = await firstValueFrom(
        this.api.post(
          '/seguro-dias/payment-complete',
          Object.assign({}, this.state, { tkn: this.state.tkn || urlParams['tkn'] || '' }),
          {}
        )
      );

      if (response?.datosPoliza?.polizaId) {
        this.state.datosPoliza = response.datosPoliza;
        this.stateService.setState(this.state);
        this.numPoliza = String(response.datosPoliza.polizaId);
        return;
      }

      this.policyErrorMessage = this.resolvePolicyErrorMessage(response);
    } catch (error: any) {
      this.policyErrorMessage = this.resolvePolicyErrorMessage(error);
    } finally {
      this.isLoadingPolicyData = false;
      this.cdr.markForCheck();
    }
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  downloadPolicy(type: number) {
    window.open(
      this.api.getFullUrl('/seguro-dias/download', {
        tipo: type,
        id: this.numPoliza,
        tkn: this.state.tkn,
      }),
      '_blank'
    );
  }

  hasPolicyData(): boolean {
    return this.numPoliza.trim() !== '';
  }

  private resolvePolicyErrorMessage(responseOrError: any): string {
    return (
      responseOrError?.error?.message ||
      responseOrError?.error ||
      responseOrError?.message ||
      responseOrError?.status ||
      'No hemos podido generar la póliza en este momento.'
    );
  }
}
